export const CAMPAIGN_CONTENT_MAPPINGS = [
  {
    CampaignCode: 'cable_cus_sms_82245_52007_engvisit_order_confirmation',
    TargetStrapiUid: 'angular-checkservices-slowornobroadband',
    NewStrapiUid: 'angular-checkservices-manage-appointment',
  },
  {
    CampaignCode: 'cable_cus_em_82245_engvisit_order_confirmation_dayx',
    TargetStrapiUid: 'angular-checkservices-slowornobroadband',
    NewStrapiUid: 'angular-checkservices-manage-appointment',
  },
  {
    CampaignCode: 'cable_cus_em_52007_engvisit_order_confirmation_day-1',
    TargetStrapiUid: 'angular-checkservices-slowornobroadband',
    NewStrapiUid: 'angular-checkservices-manage-appointment',
  },
  {
    CampaignCode: 'cable_cus_em_52007_engvisit_order_confirmation_day0',
    TargetStrapiUid: 'angular-checkservices-slowornobroadband',
    NewStrapiUid: 'angular-checkservices-manage-appointment',
  },
];
